import { useCallback } from 'react'
import { UseFieldConfig } from 'react-final-form'

export const useIsEqualWithFormat = (format?: UseFieldConfig<string>['format']) =>
  useCallback((a?: string, b?: string) => (format ? format(a || '', '') === format(b || '', '') : a === b), [format])
